import { createContext } from 'react';
//import noop from 'lodash/noop';
import { Context } from '../../../types';
import { AmadeusGateway } from '../types';
import api from '../api';
import { getContextDefaultValues } from '../../providersDataManager';

export default createContext<Context<AmadeusGateway>>(getContextDefaultValues(api));
/*
export default createContext<Context<PaymentGateway>>({
    get: api.get,
    getById: api.getById,
    getSchema: api.getSchema,
    schema: {},
    post: api.post,
    put: api.put,
    data: { ids: [], byId: {} },
    setData: noop,
    selected: null,
    setSelected: noop,
    remove: api.remove,
    error: null
});
*/
